import React, { Component } from 'react';
import { CustomCard } from "../../../../components/Card/CustomCard";
import { Timeline, Event } from "react-timeline-scribble";

import Recaudos from "../../../../shared/ReacaudosInsc";
import RecaudosEx from "../../../../shared/RecaudosEx";
import NuevIng from "../../../../shared/NuevIng";
import NotasPago from "../../../../shared/NotasPago";

class Inscripcion extends Component {

    recaudos = () => {
        return (
            Recaudos.map(option => (
                <Event interval={
                    <div className="fuente-monserrat" style ={{fontSize:14, color: "#333", marginBottom: -1}} key ={option.id}>{option.recaudo}</div>
                }></Event>
            ))
        )
    }

    recaudosEx = () => {
        return (
            RecaudosEx.map(option => (
                <Event interval={
                    <div className="fuente-monserrat" style ={{fontSize:14, color: "#333", marginBottom: -1}} key ={option.id}>{option.recaudo}</div>
                }></Event>
            ))
        )
    }

    recaudosNuevIng = () => {
        return (
            NuevIng.map(option => (
                <Event interval={
                    <div className="fuente-monserrat" style ={{fontSize:14, color: "#333", marginBottom: -1}} key ={option.id}>{option.recaudo}</div>
                }></Event>
            ))
        )
    }

    notasPago = () => (
        NotasPago.map(option => (
            <Event interval={
                <div className="fuente-monserrat" style ={{fontSize:14, color: "#333", marginBottom: -1}} key ={option.id}>{option.recaudo}</div>
            }></Event>
        ))
    )

    modalidades = () => (
        <React.Fragment>
            <Event interval={
                <div>
                    <p className="fuente-monserrat" style ={{fontSize:14, color: "#333", marginBottom: 20}}>
                        TRANSFERENCIA BANCARIA EN LAS SIGUIENTES CUENTAS:
                    </p>
                    <p className="fuente-monserrat" style ={{fontSize:12, color: "#333", paddingLeft:20}}>- BANCO PROVINCIAL: CUENTA CORRIENTE N° 0108-0020-08-0100082534</p>
                    <p className="fuente-monserrat" style ={{fontSize:12, color: "#333", paddingLeft:20}}>- BANESCO: CUENTA CORRIENTE N° 0134-0184-51-1843021286</p>
                </div>
            }></Event>
            <Event interval={
                <div>
                <p className="fuente-monserrat" style ={{fontSize:14, color: "#333", marginBottom: 20}}>
                    PAGO MÓVIL:
                </p>
                <p className="fuente-monserrat" style ={{fontSize:12, color: "#333", paddingLeft:20}}>- PAGO MÓVIL PROVINCIAL: TELÉFONO N°: 0424-1526983</p>
                <p className="fuente-monserrat" style ={{fontSize:12, color: "#333", paddingLeft:20}}>- PAGO MÓVIL BANESCO: TELÉFONO N°: 0412-3127857</p>
            </div>
            }></Event>
        </React.Fragment>
    )

    modEfectivo = () => (
        <React.Fragment>
            <Event interval={
                <div>
                    <p className="fuente-monserrat" style ={{fontSize:14, color: "#333", marginBottom: 20}}>
                        PAGO EN EFECTIVO EN EL DEPARTAMENTO DE CAJA DEL IUDLM:
                    </p>
                    <p className="fuente-monserrat" style ={{fontSize:12, color: "#333", paddingLeft:20}}>
                        Considerando que durante el período establecido para la realización de la inscripción administrativa podrá contarse con momentos de flexibilidad, se podrá cancelar en efectivo y realizar el pago de forma presencial en nuestra sede. El Departamento de Caja estará funcionando durante la semana flexible de lunes a viernes de 8:00 am a 1:30 pm. El estudiante que opte por este medio de pago deberá enviar un correo al Departamento de Administración indicando esta modalidad de pago, junto con los datos siguientes: Apellidos, Nombres, Cédula de Identidad, Carrera seleccionada, teléfono de contacto. Para atenderle estaremos cumpliendo con todas las medidas de bioseguridad y le agradecemos asistir con su tapabocas.
                    </p>
                </div>
            }></Event>
        </React.Fragment>
    )
    contenido = () => (
        <React.Fragment>
            <div id="inscripcion">
                <div className="fuente-monserrat" style ={{fontSize:18, color: "#1f2f6e", marginTop:-10, paddingLeft:25}}><strong>Inscripciones Nuevo Ingreso (Admisión)</strong></div>
                <p className="fuente-monserrat custom-mt-10" style={{fontSize:14, paddingLeft:25, paddingRight:25}}>
                Fechas De Inscripción periodo académico 2024-I: del 16 al 27 de octubre de 2023.
                </p>
                <div className="fuente-monserrat" style ={{fontSize:16, color: "#a80012", marginTop:30, paddingLeft:25}}><strong>PROCESO DE SOLICITUD DE ADMISIÓN</strong></div>
                <p className="fuente-monserrat custom-mt-10" style={{fontSize:14, paddingLeft:25, paddingRight:25}}>
                    Para ingresar por primera vez como estudiante en el IUDLM, los interesados deberán cumplir con la entrega de los siguientes recaudos:
                </p>
                <Timeline>
                    {this.recaudosNuevIng()}
                </Timeline>
                {/*
                <div className="fuente-monserrat" style ={{fontSize:16, color: "#a80012", marginTop:30, paddingLeft:25}}><strong>Apertura de Expediente (Entrega de Recaudos)</strong></div>
                <p className="fuente-monserrat custom-mt-10" style={{fontSize:14, paddingLeft:25, paddingRight:25}}>
                    Con la finalidad de formalizar la inscripción el aspirante debe consignar los siguientes documentos para la apertura de su expediente estudiantil:
                </p>
                <Timeline>
                    {this.recaudos()}
                </Timeline> */}
                <div className="fuente-monserrat" style ={{fontSize:16, color: "#a80012", marginTop:30, paddingLeft:25, marginBottom: 20}}><strong>En caso de ser Extranjero debes consignar:</strong></div>
                <Timeline>
                    {this.recaudosEx()}
                </Timeline>

                {/* <div className="fuente-monserrat" style ={{fontSize:16, color: "#a80012", paddingLeft:25}}><strong>Nota Importante</strong></div>
                <p className="fuente-monserrat custom-mt-10" style={{fontSize:14, paddingLeft:25, paddingRight:25}}>
                    El trámite de inscripción es personal, en caso de autorizar a un tercero, éste debe consignar la carta de autorización debidamente firmada o el poder notariado y las fotocopias de las cédulas de identidad de ambas partes.
                </p>

                <div className="fuente-monserrat" style ={{fontSize:16, color: "#a80012", marginTop:30, paddingLeft:25, marginBottom: 20}}><strong>Métodos de Pago y Procedimiento</strong></div>
                <p className="fuente-monserrat custom-mt-10" style={{fontSize:14, paddingLeft:25, paddingRight:25}}>
                    El pago puede realizarse a través de los siguientes medios:
                </p>
                <Timeline>
                    {this.modalidades()}
                </Timeline>
                <div className="fuente-monserrat custom-mt-10" style={{fontSize:14, paddingLeft:25, paddingRight:25}}>
                    <strong>BENEFICIARIO:</strong> INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES
                </div>
                <div className="fuente-monserrat custom-mt-10" style={{fontSize:14, paddingLeft:25, paddingRight:25, marginBottom: 20}}>
                    <strong>RIF:</strong> J- 30583313-3
                </div>
                <Timeline>
                    {this.modEfectivo()}
                </Timeline>
                <div className="fuente-monserrat custom-mt-10" style={{fontSize:14, paddingLeft:25, paddingRight:25, marginBottom: 20}}>
                    <strong>CORREO DE ADMINISTRACIÓN:</strong> administracion@iudlm.com
                </div>

                <div className="fuente-monserrat" style ={{fontSize:16, color: "#a80012", paddingLeft:25, marginBottom: 20}}>
                    <strong>EFECTUADO EL PAGO MÓVIL O LA TRANFERENCIA BANCARIA EL ESTUDIANTE DEBE OBLIGATORIAMENTE:</strong> 
                </div>
                <Timeline>
                    {this.notasPago()}
                </Timeline>

                <p className="fuente-monserrat custom-mt-10" style={{fontSize:14, paddingLeft:25, paddingRight:25, marginBottom: 40}}>
                    La factura original podrá ser retirada en el Departamento de Caja del IUDLM durante las semanas flexibles determinadas por el Ejecutivo Nacional, de lunes a viernes de 8:00 am a 1:30 pm.
                </p> */}
                <div>
                    <div className="fuente-monserrat" style ={{fontSize:16, color: "#a80012", marginTop:30, paddingLeft:25}}><strong>Instructivo de Inscripción 2024-I</strong></div>
                    <div className="custom-mt-10 fuente-monserrat" align="left" style={{color: "fff", padding: 25}}>
                        <a className="btn btn-danger fuente-monserrat" href="docs/INSTRUCTIVO INSCRIPCIONES ESTUDIANTES NUEVO INGRESO  LAPSO 2024-I.pdf" target="_blank" style={{borderWidth: 1, borderColor:"#a80012", backgroundColor:"#a80012", color:"#FFF"}} title="Descargar el Plan de Estudios">Descargar Aquí <i className="fa fa-download"></i></a>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )

    render() { 
        return (
            <CustomCard
                content={this.contenido()}
            />
        );
    }
}
 
export default Inscripcion;


// WEBPACK FOOTER //
// ./src/site/Componentes/Ingreso/Contenido/Inscripción.jsx